<div class="ui-g-12 text-right" style="float:unset;">
  <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="goBack()"
    label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-md-6">
    <span>{{ 'campaign.couponCode' | translate }}:</span>
    <span *ngIf="field.coupon_code">{{ field.coupon_code }}</span>
  </div>
  <div class="ui-g-12 ui-md-6">
    <span>{{ 'promotion.couponType' | translate }}:</span>
    <span *ngIf="field.coupon_type">{{ field.coupon_type }}</span>
  </div>
  <div class="ui-g-12 ui-md-6">
    <span>{{ 'promotion.barCode' | translate }}:</span>
    <span *ngIf="field.barcode">{{ field.barcode }}</span>
  </div>
  <div class="ui-g-12 ui-md-6">
    <span>{{ 'loyalty.card_no' | translate }}:</span>
    <span *ngIf="field.card_no">{{ field.card_no }}</span>
  </div>
</div>
<div class="ui-g ui-fluid form-group master-data customer-cards-info">
  <div class="ui-g loyalty-cluster">
    <div class="ui-g-12">
      <app-kontable #table data-testid="table" title="{{ 'campaign.couponHistory' | translate }}" [columns]="[
    { field: 'ochannel_name', title: 'campaign.touchpoint' },
    { field: 'store_host_code', title: 'common.storeCode' },
    { field: 'term_code', title: 'self_scan_trx.termCode' },
    { field: 'tx_no', title: 'common.transactionNumber' },
    { field: 'operation_type', title: 'campaign.operationType',bodyTemplate: operationTypeTemplate },
    { field: 'operation_dt', title: 'common.operation_time', bodyTemplate: operationDateTemplate },
    { field: 'coupon_amt', title: 'common.couponAmount'  },
    { field: 'coupon_reserved', title: 'common.reservationStatus',bodyTemplate: couponReservedTemplate  },
    { field: 'coupon_printed', title: 'common.printStatus',bodyTemplate: couponPrintStateTemplate }
  ]" [titles]="['loyalty.card_no']" [source]="couponList" [paginationType]="paginationType" [showRecoverButton]="false"
        [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
        [showEditButton]="false" [showReport]="false" [showGlobalFilter]="false">

        <ng-template #couponReservedTemplate let-row>
          <span>{{ getCouponReserved(row.coupon_reserved) }}</span>
        </ng-template>
        <ng-template #couponPrintStateTemplate let-row>
          <span>{{ getCouponPrintState(row.coupon_printed) }}</span>
        </ng-template>
        <ng-template #operationDateTemplate let-row>
          <span>{{ row.operation_dt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
        </ng-template>

<ng-template #operationTypeTemplate let-row>
  <span>{{ operationTypeMap[row.operation_type] || row.operation_type }}</span>
</ng-template>

      </app-kontable>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/coupon-manager/coupon-history/coupon-history.component.html